import React, { Component } from 'react';
import { Link } from 'react-router'
import Butter from 'buttercms'

import {} from './BlogHome.css';

const butter = Butter('75d2c0d6325d45a1434fb429cb750f018d7c41d9');

class BlogHome extends Component {

  constructor(props) {
    super(props);
    document.title = "g-C3N4 Blog";

    this.state = {
      loaded: false
    };
  }

  fetchPosts(page) {
    butter.post.list({page: page, page_size: 10}).then((resp) => {
      this.setState({
        loaded: true,
        resp: resp.data
      })
    });
  }

  componentWillMount() {
    let page = this.props.params.page || 1;

    this.fetchPosts(page)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({loaded: false});

    let page = nextProps.params.page || 1;

    this.fetchPosts(page)
  }

  render() {
    if (this.state.loaded) {
      const { next_page, previous_page } = this.state.resp.meta;
 
      return (
        <div className="container">
          <p className="title">Blog </p>
          <p className="subtitle">Various unsubstantiated thoughts and theories on the subject... </p>
      
          {this.state.resp.data.map((post) => {
            return (
              <div key={post.slug}>
                <Link to={`/post/${post.slug}`}><p className="Blog-home-title Left"> {post.title}</p><p className="Blog-home-created Right"> {post.created.substring(0,10)}</p></Link>
              </div>
            )
          })}

          <br />

          <div>
            {previous_page && <Link to={`/p/${previous_page}`}>Prev</Link>}

            {next_page && <Link to={`/p/${next_page}`}>Next</Link>}
          </div>
        </div>
      );
    } else {
      return (
        <div>
          Loading...
        </div>
      )
    }
  }
}

export default BlogHome;


// WEBPACK FOOTER //
// ./src/Blog/BlogHome.js